import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";
import { TextField } from "../../TextField/TextField.styled";

interface JobDetailsSectionProps {
    name: string;
    dueDate: string;
}

export const JobDetailsSection = ({ name, dueDate }: JobDetailsSectionProps) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" justifyContent="center">
            <Box display="flex" justifyContent="space-between" width="100%" flexWrap="wrap">
                <TextField label={t("briefingForm.label.customer")} value={name} disabled />
                <TextField label={t("briefingForm.label.dueDate")} value={dueDate} disabled />
            </Box>
        </Box>
    );
};
